import React from 'react';

import Homepage from './Homepage';
import * as routes from '../../settings/_routesSettings';

const HomepagePsiq = () => {
  return (
    <Homepage
      config={{
        type: 'PSIQ',
        title: 'psiquiatra',
        url: routes.HOME_PSIQ,
        statusCode: 'STS24001',
        productCode: 'PRO01003',
      }}
    />
  );
};

export { HomepagePsiq };
